export default __webpack_public_path__ + "static/media/d-5.59174a4e.png";